import { TealiumBaseEvent } from './TealiumBaseEvent';

export class TealiumProductClickEvent extends TealiumBaseEvent {
  static readonly PRODUCT_CLICK_EVENT = 'product_click';

  constructor() {
    super(TealiumProductClickEvent.PRODUCT_CLICK_EVENT);

    this.product_keys = [...this.product_keys, 'product_attributes_position'];
    this.uTagInfoMap = this.buildUTagProductInfoMap();
  }
}
